import { ICopyInspecaoObraUseCase } from "../../../presentation/useCases/create/copy_inspecao_obra_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * CopyInspecaoObraUseCase
 */

export class CopyInspecaoObraUseCase implements ICopyInspecaoObraUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async copyInspecaoObra(
    idInspecaoObra: number,
    copyNumber: number,
  ): Promise<void> {
    await this.repository.copyInspecaoObra(
      idInspecaoObra,
      copyNumber,
    );
  }
}
